import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import CompleteSolution from './components/CompleteSolution';
import About from './components/About';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import GalleryPage from './components/GalleryPage';
import Footer from './components/Footer';
import StickyMobileContact from './components/StickyMobileContact';
import ServiceDetail from './components/ServiceDetail';
import ScrollProgressBar from './components/ScrollProgressBar';
import ScrollToTop from './components/ScrollToTop';
import { companyData } from './data';

function App() {
  const location = useLocation();

  // Set SEO Title and Meta Description dynamically
  useEffect(() => {
    document.title = companyData.seo.title;

    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', companyData.seo.description);
  }, []);

  // Handle scrolling to hash links when navigating across pages
  useEffect(() => {
    if (location.hash) {
      const id = location.hash;
      const element = document.querySelector(id);
      if (element) {
        setTimeout(() => {
          const offset = 80; // height of sticky header
          const bodyRect = document.body.getBoundingClientRect().top;
          const elementRect = element.getBoundingClientRect().top;
          const elementPosition = elementRect - bodyRect;
          const offsetPosition = elementPosition - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }, 150); // Small delay to allow page to render
      }
    } else if (location.pathname === '/') {
      // Scroll to top when navigating to home without a hash
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location]);

  return (
    <div className="relative min-h-screen bg-[#111111] text-white antialiased selection:bg-orange-500 selection:text-white pb-16 md:pb-0">
      {/* Scroll Progress Bar */}
      <ScrollProgressBar />

      {/* Subtle background grid pattern */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.02] z-0"
        style={{
          backgroundImage:
            'linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)',
          backgroundSize: '48px 48px',
        }}
      />

      {/* Header Navigation */}
      <Header />

      {/* Routes */}
      <Routes>
        {/* Forside (Home Route) */}
        <Route
          path="/"
          element={
            <main className="relative z-10">
              <Hero />
              <CompleteSolution />
              <About />
              <Gallery />
            </main>
          }
        />

        {/* Service Detail Route */}
        <Route
          path="/ydelser/:id"
          element={
            <main className="relative z-10 pt-[113px] md:pt-[140px]">
              <ServiceDetail />
            </main>
          }
        />

        {/* Kontaktunderside (Contact Route) */}
        <Route
          path="/kontakt"
          element={
            <main className="relative z-10 pt-[113px] md:pt-[140px]">
              <Contact />
            </main>
          }
        />

        {/* Galleriunderside (Gallery Route) */}
        <Route
          path="/galleri"
          element={
            <main className="relative z-10 pt-[113px] md:pt-[140px]">
              <GalleryPage />
            </main>
          }
        />
      </Routes>

      {/* Footer */}
      <Footer />

      {/* Scroll to Top Button */}
      <ScrollToTop />

      {/* Sticky Mobile Contact Bar */}
      <StickyMobileContact />
    </div>
  );
}

export default App;
